/* eslint-disable camelcase */
import React, { createContext, useContext, useEffect, useState } from 'react'
import { socket } from '../services/socketApi'

const SocketContext = createContext()

export const useSocket = () => {
  return useContext(SocketContext)
}

export const SocketProvider = ({ children }) => {
  const [isConnected, setIsConnected] = useState(socket.connected)

  const onlineUsers = () => {
    socket.on('user:users_online', () => {
      console.log('Users online')
    })
  }
  const onConnect = () => {
    const id_user = localStorage.getItem('id_user')

    if (id_user) {
      // socket.emit('user:connected', { id_user })
      setIsConnected(true)
    }
  }

  useEffect(() => {
    // eslint-disable-next-line camelcase
    socket.connect()

    socket.on('connect', onConnect)

    return () => {
      socket.off('connect')
      socket.disconnect()
    }
  }, [])

  return (
    <SocketContext.Provider
      value={{ socket, onlineUsers, onConnect, isConnected }}
    >
      {children}
    </SocketContext.Provider>
  )
}
